import { render, staticRenderFns } from "./ForgotPw.vue?vue&type=template&id=e60d011c&scoped=true"
import script from "./ForgotPw.vue?vue&type=script&lang=js"
export * from "./ForgotPw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60d011c",
  null
  
)

export default component.exports